/**
 * DOS518 — Integrazione ASTUTO
 * clipboardAdapter.ts — Import via testo incollato (clipboard / QR code).
 *
 * Tenta i parser in ordine:
 *   1. JSON (stringa che inizia con "{")
 *   2. XML  (stringa che inizia con "<")
 *   3. CSV  (fallback)
 */

import type { AstutoAdapter } from './baseAdapter';
import type { AstutoResult } from '../types';
import { parseJSON } from '../parsers/jsonParser';
import { parseXML }  from '../parsers/xmlParser';
import { parseCSV }  from '../parsers/csvParser';

export class ClipboardAdapter implements AstutoAdapter {
  readonly name = 'Clipboard / QR (testo incollato)';

  async fetch(input?: File | string): Promise<AstutoResult> {
    if (typeof input !== 'string' || !input.trim()) {
      return { ok: false, error: 'Nessun testo da analizzare. Incolla i dati ASTUTO nel campo apposito.' };
    }

    const text = input.trim();

    // Tenta JSON
    if (text.startsWith('{') || text.startsWith('[')) {
      try {
        return { ok: true, data: parseJSON(text) };
      } catch {
        // Continua
      }
    }

    // Tenta XML
    if (text.startsWith('<')) {
      try {
        return { ok: true, data: parseXML(text) };
      } catch {
        // Continua
      }
    }

    // Tenta CSV come fallback
    try {
      const data = parseCSV(text);
      if (data.personale.length > 0 || data.mezziTerrestri.length > 0) {
        return { ok: true, data };
      }
    } catch {
      // Continua
    }

    return {
      ok: false,
      error: 'Formato non riconosciuto. Il testo incollato non è un export ASTUTO valido (JSON, XML o CSV).',
    };
  }
}
